import React from 'react';
import { UseFormReturn } from "react-hook-form";
import { 
  Select, 
  SelectContent, 
  SelectItem, 
  SelectTrigger, 
  SelectValue 
} from "@/components/ui/select";
import { 
  FormField, 
  FormItem, 
  FormLabel, 
  FormControl, 
  FormMessage 
} from "@/components/ui/form";

interface ContactFormSourceProps {
  form: UseFormReturn<any>;
}

const ContactFormSource = ({ form }: ContactFormSourceProps) => {
  return (
    <FormField
      control={form.control}
      name="source"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Hoe heb je ons gevonden?</FormLabel>
          <Select onValueChange={field.onChange} defaultValue={field.value}>
            <FormControl>
              <SelectTrigger>
                <SelectValue placeholder="Selecteer een optie..." />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              <SelectItem value="google">Google</SelectItem>
              <SelectItem value="referral">Aanbeveling</SelectItem>
              <SelectItem value="website">Website</SelectItem>
              <SelectItem value="other">Anders</SelectItem>
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default ContactFormSource;
